import { toPublicLocalePath } from '@design-system/utils/publicLocalePath'

/**
 * Mantiene `/en/` nella barra degli indirizzi quando il routing interno usa `en-wx`.
 * L'edge rewrite serve il contenuto di en-wx su /en, ma Vue Router può sincronizzare
 * l'URL sul path interno dopo l'idratazione.
 */
export default defineNuxtPlugin(() => {
  if (useRuntimeConfig().public.isFederated) return

  const router = useRouter()

  const syncPublicIntlUrl = () => {
    const { pathname, search, hash } = window.location
    const publicPath = toPublicLocalePath(pathname)
    if (publicPath === pathname) return
    history.replaceState(history.state, '', `${publicPath}${search}${hash}`)
  }

  syncPublicIntlUrl()

  router.afterEach(() => {
    syncPublicIntlUrl()
  })
})
